import {useLazyQuery} from '@apollo/client';
import {lookupQueries} from 'api';
import {LookupListingRequest, LookUpsPaginationResponse} from 'models';

export const useGetLookUps = () => {
    const [getLookups, {data, loading}] = useLazyQuery<LookUpsPaginationResponse, LookupListingRequest>(
        lookupQueries.LOOKUPS,
        {
            fetchPolicy: 'no-cache',
        },
    );

    return {
        getLookups,
        getLookupsLoading: loading,
        getLookupsResponse: data?.lookUps,
    };
};
